import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { BASE_URL } from '../apiConfig'

export const updateUserDetails = createAsyncThunk(
    'updateUserDetails',
    async ({ jwtBearer, requestBody }) => {
        console.log('Request Body - ', requestBody)
        const options = {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + jwtBearer,
                'Content-Type': 'application/json' // Set content type to JSON
            },
            body: JSON.stringify(requestBody) // Wrap requestBody as needed
        }

        try {
            const response = await fetch(
                `${BASE_URL}admin/update/user/details/`,
                options
            )
            console.log('Request Options - ', options)
            console.log('Response -- ', response)
            console.log('Response Payload - ', response.status)
            // if(response.status == 201) {
            //   alert('Old and new password does not match.')
            // }
            return response.json() // Assuming the response is JSON
        } catch (error) {
            console.log('Error', error)
            alert(error.message)
            throw error
        }
    }
)

const updateUserDetailsSlice = createSlice({
    name: 'updateUserDetails',
    initialState: {
        isLoading: false,
        data: null,
        isError: false,
        errorMessage: null
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateUserDetails.pending, state => {
            state.isLoading = true
            state.isError = false
            state.errorMessage = null
        })
        builder.addCase(updateUserDetails.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
            state.isError = false
            state.errorMessage = null
        })
        builder.addCase(updateUserDetails.rejected, (state, action) => {
            state.isLoading = false
            state.isError = true
            state.errorMessage = action.error.message
        })
    }
})

export default updateUserDetailsSlice.reducer
